import { useParams } from 'react-router'

export const useIntakeId = () => {
  const { intakeId } = useParams<{ intakeId: string }>()

  return intakeId
}

export default useIntakeId
